import React from 'react'
import styled from '@emotion/styled'
import Loading from '../../Loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBug } from '@fortawesome/pro-solid-svg-icons'

const L1ImageImg = styled.img(({ width, height, onClick }) => ({
	maxWidth: '100%',
	maxHeight: '100%',
	width: width ? width : 'auto',
	height: height ? height : 'auto',
	cursor: onClick ? 'pointer' : 'auto',
}))

const L1ImageThumbnailImg = styled(L1ImageImg)(({ theme }) => ({
	borderRadius: theme.borderRadius,
	width: '100px',
}))

interface L1ImageProps {
	loading: boolean
	error: boolean
	thumbnail?: boolean
	src?: string
	width?: string|number
	height?: string|number
	onClick?: React.MouseEventHandler<HTMLImageElement>
}

export const L1Image = ({ loading, error, thumbnail, src, width, height, onClick }: L1ImageProps) => {
	if(loading) {
		return <Loading size="2x" />
	}
	if(error) {
		return <FontAwesomeIcon icon={faBug} size="2x" />
	}
	if(thumbnail) {
		return (
			<L1ImageThumbnailImg
				src={src}
				onClick={onClick}
			/>
		)
	}
	return (
		<L1ImageImg
			src={src}
			width={width}
			height={height}
			onClick={onClick}
		/>
	)
}
